import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
  // Changing this value clears a caught error without unmounting the
  // boundary itself. Unmounting it (e.g. via `key`) is unsafe here: the
  // route-change that should recover from the error is itself what
  // unmounts the old subtree, so a boundary torn down in that same commit
  // is not around anymore to catch it.
  resetKey?: unknown
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Erro não tratado na aplicação:', error, info.componentStack)
  }

  componentDidUpdate(prevProps: Props) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-screen w-full flex-col items-center justify-center gap-4 p-8 text-center">
          <h1 className="text-lg font-semibold">
            Ocorreu um erro inesperado
          </h1>
          <p className="text-sm text-zinc-500">
            Tente recarregar a página. Se o problema persistir, contate o
            suporte.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-md bg-zinc-900 px-4 py-2 text-sm text-white"
          >
            Recarregar página
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
